module.exports = __webpack_public_path__ + "static/media/react-logo.9675648e.svg";